import product from '@ppcp/product';
import cart from '@ppcp/cart';
import {getSetting} from '@ppcp/utils';
import {ProductController} from '@ppcp/controllers';
import Context from '@ppcp/context';
import PayPalGateway from '../gateways/PayPalGateway';

const settings = getSetting('ppcp_data');
const productSettings = getSetting('productSettings');

// Create PayPal gateway
const gateway = new PayPalGateway({
    id: 'ppcp',
    cart,
    settings: {
        ...settings,
        product: productSettings
    },
    controller: null // Will be set after controller creation
});

// Create product controller with gateway
const controller = new ProductController(product, {
    id: 'ppcp',
    cart,
    context: new Context('product'),
    gateway,
    settings: {
        ...settings,
        product: productSettings
    }
});

controller.initialize();